import { z } from "zod";

import { LIMITS } from "../constants";

/** Only images: everything an upload feeds is shown on a page. */
export const IMAGE_UPLOAD_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"] as const;

/**
 * What the browser declares before uploading straight to the bucket. Each field ends up
 * in the signature, so a declaration outside these bounds never gets a URL at all.
 */
export const createUploadSchema = z.object({
  filename: z.string().trim().min(1).max(LIMITS.filenameMax),
  contentType: z.enum(IMAGE_UPLOAD_TYPES, "Formats acceptés : JPEG, PNG, WebP ou GIF."),
  size: z.number().int().min(1).max(LIMITS.uploadSizeMax, "L'image doit faire moins de 10 Mo."),
});

export type CreateUploadInput = z.input<typeof createUploadSchema>;
